<div class="main-content mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a class="btn btn-dark btn-sm btn-new" [routerLink]="['/marketing']">
            Keywords
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/offPageCampaigns/urlMapping']"
          >
            URL Mapping
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/onPage']"
          >
            On-Page
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/internalLinks/add']"
          >
            Internal Links
          </a>
        </div>
      </div>
    </div>

    <div class="row pb-3">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/technicalQa']"
          >
            Technical QA
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/localSeo']"
          >
            Local SEO
          </a>
          <a class="btn btn-dark btn-sm btn-reg"> Off-Page </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/performance']"
          >
            Performance
          </a>
        </div>
      </div>
    </div>
    <div class="url-mapping-container p-4" *ngIf="!loading">
      <!-- ── HEADER ─────────────────────────────────────────────────────── -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div class="d-flex align-items-center gap-3">
          <div class="header-icon bg-primary text-white rounded p-2">
            <i class="fas fa-link fa-lg"></i>
          </div>
          <div class="pl-2">
            <h2 class="h4 mb-0 fw-bold">OFF-PAGE</h2>
            <!-- <p class="text-muted mb-0 small">
              Build and protect external authority. Attract the right links,
              mentions and partnerships to the right pages.
            </p> -->
          </div>
        </div>
        <div class="d-flex gap-2">
          <!-- <button class="btn btn-outline-secondary btn-sm p-1 btn-header">
            <i class="fas fa-play-circle me-1"></i> How it works
          </button> -->
          <button class="btn btn-outline-secondary btn-sm p-1 btn-header">
            <i class="fas fa-download me-1"></i> Export Report
          </button>
          <!-- <button class="btn btn-sm btn-add p-1 btn-header">
            <i class="fas fa-plus me-1"></i> New Off-Page Review
          </button> -->
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="row px-3">
            <div class="col-3">
              <label class="text-dark" for="urlMapping"
                ><strong>Filters</strong></label
              >
            </div>
            <div class="col-9 d-flex justify-content-end pr-0">
              <button
                class="btn btn-outline-secondary btn-sm btn-filter"
                (click)="onFilterChange()"
              >
                Find
              </button>
            </div>
          </div>
          <!-- ── FILTERS ────────────────────────────────────────────────────── -->
          <div class="row mb-0 px-3 flex-nowrap">
            <!-- Universe -->
            <div class="col filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Universe</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingUniverse"
              >
                <option *ngFor="let u of universes" [value]="u.value">
                  {{ u.label }}
                </option>
              </select>
            </div>

            <!-- Market -->
            <div class="col filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Market</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingMarket"
              >
                <option *ngFor="let m of markets" [value]="m.value">
                  {{ m.label }}
                </option>
              </select>
            </div>

            <!-- Link Type -->
            <div class="col filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Link Type</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingLinkType"
              >
                <option *ngFor="let lt of linkTypes" [value]="lt.value">
                  {{ lt.label }}
                </option>
              </select>
            </div>

            <!-- Authority Source -->
            <div class="col filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Authority Source</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingSource"
              >
                <option *ngFor="let s of sources" [value]="s.value">
                  {{ s.label }}
                </option>
              </select>
            </div>

            <!-- Destination URL -->
            <div class="col filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Destination URL</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingDestination"
              >
                <option *ngFor="let d of destinations" [value]="d.value">
                  {{ d.label }}
                </option>
              </select>
            </div>

            <!-- Issue / Opportunity Type -->
            <div class="col filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Issue / Opportunity Type</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingType"
              >
                <option *ngFor="let t of types" [value]="t.value">
                  {{ t.label }}
                </option>
              </select>
            </div>

            <!-- Status -->
            <div class="col filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Status</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingStatus"
              >
                <option *ngFor="let st of statuses" [value]="st.value">
                  {{ st.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <!-- ── STAT CARDS ────────────────────────────────────────────────── style="min-width: 175px-->
          <div class="row">
            <div class="col-12">
              <div
                class="row m-0 align-items-stretch flex-nowrap custom-scroll-x p-0 gap-3"
              >
                <!-- Referring Domains -->
                <div class="col p-0 pr-1 d-flex">
                  <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                    <div class="card-body px-1 py-1 d-flex">
                      <div class="stat-icon-filled bg-blue me-3">
                        <i class="fas fa-globe"></i>
                      </div>
                      <div class="space-cards">
                        <div
                          class="text-uppercase fw-bold text-dark mb-1"
                          style="font-size: 0.63rem; letter-spacing: 0.5px"
                        >
                          <strong>REFERRING DOMAINS</strong>
                        </div>
                        <h3 class="mb-1 fw-bold text-dark">
                          {{ stats.referringDomains.value }}
                        </h3>
                        <div class="small fw-medium text-success">
                          <i class="fas fa-arrow-up"></i>
                          {{ stats.referringDomains.trend }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Total Backlinks -->
                <div class="col p-0 pr-1 d-flex">
                  <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                    <div class="card-body px-1 py-1 d-flex">
                      <div class="stat-icon-filled bg-green me-3">
                        <i class="fas fa-link"></i>
                      </div>
                      <div class="space-cards">
                        <div
                          class="text-uppercase fw-bold text-dark mb-1"
                          style="font-size: 0.63rem; letter-spacing: 0.5px"
                        >
                          <strong>TOTAL BACKLINKS</strong>
                        </div>
                        <h3 class="mb-1 fw-bold text-dark">
                          {{ stats.totalBacklinks.value }}
                        </h3>
                        <div class="small fw-medium text-success">
                          <i class="fas fa-arrow-up"></i>
                          {{ stats.totalBacklinks.trend }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- New Links -->
                <div class="col p-0 pr-1 d-flex">
                  <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                    <div class="card-body px-1 py-1 d-flex">
                      <div class="stat-icon-filled bg-orange me-3">
                        <i class="fas fa-plus"></i>
                      </div>
                      <div class="space-cards">
                        <div
                          class="text-uppercase fw-bold text-dark mb-1"
                          style="font-size: 0.63rem; letter-spacing: 0.5px"
                        >
                          <strong>NEW LINKS</strong>
                        </div>
                        <h3 class="mb-1 fw-bold text-dark">
                          {{ stats.newLinks.value }}
                        </h3>
                        <div class="small fw-medium text-success">
                          <i class="fas fa-arrow-up"></i>
                          {{ stats.newLinks.trend }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Lost Links -->
                <div class="col p-0 pr-1 d-flex">
                  <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                    <div class="card-body px-1 py-1 d-flex">
                      <div class="stat-icon-filled bg-red me-3">
                        <i class="fas fa-times"></i>
                      </div>
                      <div class="space-cards">
                        <div
                          class="text-uppercase fw-bold text-dark mb-1"
                          style="font-size: 0.63rem; letter-spacing: 0.5px"
                        >
                          <strong>LOST LINKS</strong>
                        </div>
                        <h3 class="mb-1 fw-bold text-dark">
                          {{ stats.lostLinks.value }}
                        </h3>
                        <div class="small fw-medium text-danger">
                          <i class="fas fa-arrow-up"></i>
                          {{ stats.lostLinks.trend }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Domain Authority -->
                <div class="col p-0 pr-1 d-flex">
                  <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                    <div class="card-body px-1 py-1 d-flex">
                      <div class="stat-icon-filled bg-purple me-3">
                        <i class="fas fa-shield-alt"></i>
                      </div>
                      <div class="space-cards">
                        <div
                          class="text-uppercase fw-bold text-dark mb-1"
                          style="font-size: 0.63rem; letter-spacing: 0.5px"
                        >
                          <strong>DOMAIN AUTHORITY</strong>
                        </div>
                        <h3 class="mb-1 fw-bold text-dark">
                          {{ stats.domainAuthority.value }}
                        </h3>
                        <div class="small fw-medium text-success">
                          <i class="fas fa-arrow-up"></i>
                          {{ stats.domainAuthority.trend }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Authority Health -->
                <div class="col p-0 pr-1 d-flex">
                  <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                    <div class="card-body px-1 py-1 d-flex">
                      <div
                        class="stat-icon-filled bg-info me-3"
                        style="background-color: #008080 !important"
                      >
                        <i class="fas fa-heartbeat"></i>
                      </div>
                      <div class="space-cards">
                        <div
                          class="text-uppercase fw-bold text-dark mb-1"
                          style="font-size: 0.63rem; letter-spacing: 0.5px"
                        >
                          <strong>AUTHORITY HEALTH</strong>
                        </div>
                        <h3 class="mb-1 fw-bold text-dark">
                          {{ stats.authorityHealth.value }}%
                        </h3>
                        <div class="small fw-medium text-success">
                          <i class="fas fa-arrow-up"></i>
                          {{ stats.authorityHealth.trend }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- High-Priority Issues -->
                <div class="col p-0 pr-1 d-flex">
                  <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                    <div class="card-body px-1 py-1 d-flex">
                      <div class="stat-icon-filled bg-warning me-3">
                        <i class="fas fa-exclamation-triangle"></i>
                      </div>
                      <div class="space-cards">
                        <div
                          class="text-uppercase fw-bold text-dark mb-1"
                          style="font-size: 0.63rem; letter-spacing: 0.5px"
                        >
                          <strong>HIGH-PRIORITY ISSUES</strong>
                        </div>
                        <h3 class="mb-1 fw-bold text-dark">
                          {{ stats.highPriorityIssues.value }}
                        </h3>
                        <div class="small fw-medium text-danger">
                          <i class="fas fa-arrow-down"></i>
                          {{ stats.highPriorityIssues.trend }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row">
        <div class="col-12 pr-0 d-flex pl-0"> w-100 m-0-->
      <div class="row">
        <!-- 1. AUTHORITY ISSUES QUEUE (col-6) -->
        <div class="col-12 d-flex">
          <div class="card shadow-sm mb-2 mt-0 flex-grow-1">
            <div class="card-header bg-white border-bottom-0 pb-0 px-0">
              <h4 class="fw-bold fs-6 mb-2 text-dark pl-3">
                <strong>AUTHORITY ISSUES QUEUE</strong>
                <i class="fas fa-info-circle text-muted ms-1 small pl-1"></i>
              </h4>
              <ul
                class="nav nav-tabs nav-tabs-custom flex-nowrap custom-scroll-x px-0 pb-4 ul-tabs-custom"
              >
                <li class="nav-item" *ngFor="let tab of issuesTabs">
                  <a
                    class="nav-link fw-bold"
                    [class.active]="issuesActiveTab === tab.key"
                    href="javascript:void(0)"
                    (click)="setIssuesTab(tab.key)"
                  >
                    <strong [class]="tab.colorClass">{{ tab.label }}</strong>
                    <span class="badge bg-light border text-dark ms-1">{{
                      tab.count
                    }}</span>
                  </a>
                </li>
              </ul>
            </div>
            <div class="card-body p-0">
              <div
                class="table-responsive"
                style="max-height: 480px; overflow-y: auto"
              >
                <table class="table table-hover align-middle mb-0 text-sm">
                  <thead class="bg-light small text-uppercase">
                    <tr>
                      <th
                        class="ps-3 kw-url-mapping-header"
                        style="width: 30px"
                      ></th>
                      <th class="kw-url-mapping-header">
                        <strong>ISSUE TYPE</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>SOURCE / DOMAIN</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>DESTINATION URL</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>DETAILS</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>STATUS</strong>
                      </th>
                      <th class="pe-3 kw-url-mapping-header">
                        <strong>RECOMMENDED</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let row of getFilteredIssues()"
                      [class.table-active]="
                        selectedIssue &&
                        selectedIssue.domain === row.domain &&
                        selectedIssue.selectedType === 'issue'
                      "
                      (click)="selectIssue(row)"
                      style="cursor: pointer"
                    >
                      <td class="ps-3">
                        <input type="checkbox" class="form-check-input" />
                      </td>
                      <td>
                        <span class="fw-semibold" style="font-size: 0.75rem">
                          <i
                            class="fas me-1"
                            [ngClass]="{
                              'fa-times-circle text-danger':
                                row.type.includes('Lost') ||
                                row.type.includes('Broken'),
                              'fa-exclamation-circle text-warning':
                                row.type.includes('Misallocation'),
                              'fa-radiation text-danger':
                                row.type.includes('Toxic') ||
                                row.type.includes('Suspicious'),
                            }"
                          ></i
                          >{{ row.type }}
                        </span>
                      </td>
                      <td class="text-primary fw-medium">
                        {{ row.domain }}
                      </td>
                      <td
                        class="text-muted text-truncate"
                        style="max-width: 110px"
                        title="{{ row.destinationUrl }}"
                      >
                        {{ row.destinationUrl }}
                      </td>
                      <td>
                        <span
                          class="badge rounded-pill text-transformNone"
                          [class]="getPriorityClass(row.details)"
                        >
                          {{ row.details }}
                        </span>
                      </td>
                      <td>
                        <span
                          class="badge rounded-pill text-transformNone"
                          [class]="getStatusClass(row.status)"
                        >
                          {{ row.status }}
                        </span>
                      </td>
                      <td class="pe-3 text-muted small">
                        <div>{{ row.date }}</div>
                        <div
                          class="text-primary fw-semibold"
                          style="font-size: 0.65rem"
                        >
                          / {{ row.recommendedAction }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Pagination -->
              <!-- <div
                    class="d-flex justify-content-between align-items-center p-3 border-top bg-light custom-scroll-x"
                  >
                    <span class="small text-muted"
                      >Showing 1 to 8 of 58 results</span
                    >
                    <div class="d-flex gap-1">
                      <button class="btn btn-sm btn-outline-secondary px-2">
                        <i class="fas fa-chevron-left"></i>
                      </button>
                      <button class="btn btn-sm btn-dark px-2">1</button>
                      <button class="btn btn-sm btn-outline-secondary px-2">
                        2
                      </button>
                      <button class="btn btn-sm btn-outline-secondary px-2">
                        3
                      </button>
                      <span class="px-2">...</span>
                      <button class="btn btn-sm btn-outline-secondary px-2">
                        8
                      </button>
                      <button class="btn btn-sm btn-outline-secondary px-2">
                        <i class="fas fa-chevron-right"></i>
                      </button>
                    </div>
                    <select class="form-select form-select-sm w-auto">
                      <option>10 / page</option>
                    </select>
                  </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <!-- 2. AUTHORITY OPPORTUNITIES (col-6) -->
        <div class="col-12 d-flex">
          <div class="card shadow-sm mb-4 flex-grow-1">
            <div class="card-header bg-white border-bottom-0 pb-0 px-0">
              <h4 class="fw-bold fs-6 mb-2 text-dark pl-3">
                <strong>AUTHORITY OPPORTUNITIES</strong>
                <i class="fas fa-info-circle text-muted ms-1 small pl-1"></i>
              </h4>
              <ul
                class="nav nav-tabs nav-tabs-custom flex-nowrap custom-scroll-x px-0 pb-4 ul-tabs-custom"
              >
                <li class="nav-item" *ngFor="let tab of oppTabs">
                  <a
                    class="nav-link fw-bold"
                    [class.active]="oppActiveTab === tab.key"
                    href="javascript:void(0)"
                    (click)="setOppTab(tab.key)"
                  >
                    <strong [class]="tab.colorClass">{{ tab.label }}</strong>
                    <span class="badge bg-light border text-dark ms-1">{{
                      tab.count
                    }}</span>
                  </a>
                </li>
              </ul>
            </div>
            <div class="card-body p-0">
              <div
                class="table-responsive"
                style="max-height: 480px; overflow-y: auto"
              >
                <table class="table table-hover align-middle mb-0 text-sm">
                  <thead class="bg-light small text-uppercase">
                    <tr>
                      <th
                        class="ps-3 kw-url-mapping-header"
                        style="width: 30px"
                      ></th>
                      <th class="kw-url-mapping-header">
                        <strong>OPPORTUNITY</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>SOURCE / DOMAIN</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>TYPE</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>AUTHORITY</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>RELEVANCE</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>STATUS</strong>
                      </th>
                      <th class="pe-3 kw-url-mapping-header">
                        <strong>PRIORITY</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let row of getFilteredOpportunities()"
                      [class.table-active]="
                        selectedIssue &&
                        selectedIssue.domain === row.domain &&
                        selectedIssue.selectedType === 'opportunity'
                      "
                      (click)="selectIssue(row)"
                      style="cursor: pointer"
                    >
                      <td class="ps-3">
                        <input type="checkbox" class="form-check-input" />
                      </td>
                      <td>
                        <span class="fw-semibold" style="font-size: 0.75rem">
                          <i class="fas fa-magic text-success me-1"></i
                          >{{ row.type }}
                        </span>
                      </td>
                      <td class="text-primary fw-medium">
                        {{ row.domain }}
                      </td>
                      <td class="text-muted">{{ row.sourceType }}</td>
                      <td>
                        <span
                          class="badge rounded-pill text-transformNone"
                          [ngClass]="
                            row.authority >= 70
                              ? 'bg-dark-light text-dark'
                              : 'bg-danger-light text-danger'
                          "
                        >
                          {{ row.authority }}
                        </span>
                      </td>
                      <td class="fw-bold">
                        <span
                          class="badge rounded-pill text-transformNone"
                          [ngClass]="
                            row.relevance === 'High'
                              ? 'bg-success text-white'
                              : 'bg-warning text-dark'
                          "
                          >{{ row.relevance }}</span
                        >
                      </td>
                      <td>
                        <span
                          class="badge rounded-pill text-transformNone text-dark"
                        >
                          {{ row.status }}
                        </span>
                      </td>
                      <td class="pe-3 fw-bold">
                        <span
                          class="badge rounded-pill text-transformNone"
                          [ngClass]="
                            row.priority === 'High'
                              ? 'bg-danger-light text-danger'
                              : 'bg-warning-light text-warning'
                          "
                          >{{ row.priority }}</span
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Pagination -->
              <!-- <div
                    class="d-flex justify-content-between align-items-center p-3 border-top bg-light custom-scroll-x"
                  >
                    <span class="small text-muted"
                      >Showing 1 to 8 of 58 results</span
                    >
                    <div class="d-flex gap-1">
                      <button class="btn btn-sm btn-outline-secondary px-2">
                        <i class="fas fa-chevron-left"></i>
                      </button>
                      <button class="btn btn-sm btn-dark px-2">1</button>
                      <button class="btn btn-sm btn-outline-secondary px-2">
                        2
                      </button>
                      <button class="btn btn-sm btn-outline-secondary px-2">
                        3
                      </button>
                      <span class="px-2">...</span>
                      <button class="btn btn-sm btn-outline-secondary px-2">
                        8
                      </button>
                      <button class="btn btn-sm btn-outline-secondary px-2">
                        <i class="fas fa-chevron-right"></i>
                      </button>
                    </div>
                    <select class="form-select form-select-sm w-auto">
                      <option>10 / page</option>
                    </select>
                  </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- </div>
      </div> -->

      <div class="row">
        <div class="col-6 pr-0 d-flex">
          <div class="card shadow-sm mb-4 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 d-flex justify-content-between align-items-center pb-0 pt-3 p-2"
            >
              <h4 class="fw-bold text-uppercase mb-0 pl-2 small">
                <strong>SELECTED ITEM REVIEW</strong>
              </h4>
              <button class="btn btn-sm btn-link text-muted">
                <i class="fas fa-times"></i>
              </button>
            </div>
            <div class="card-body pt-2 pl-2">
              <div
                *ngIf="selectedIssue"
                class="d-flex align-items-center mb-3 pl-2 gap-2"
              >
                <span class="badge bg-primary-light text-primary font-size11">{{
                  selectedIssue.selectedType | uppercase
                }}</span>
                <span
                  class="bg-danger-light text-danger pl-2"
                  style="font-size: 0.8rem"
                >
                  {{ selectedIssue.type }}
                </span>
              </div>

              <div *ngIf="selectedIssue" class="table-responsive">
                <table
                  class="table table-sm table-borderless small mb-3 border-bottom"
                >
                  <tbody>
                    <tr>
                      <td class="text-dark" style="font-size: 0.78rem">
                        Source / Domain
                      </td>
                      <td
                        class="text-end fw-bold text-dark text-primary"
                        style="font-size: 0.78rem"
                      >
                        {{ selectedIssue.domain }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark" style="font-size: 0.78rem">
                        Source Type
                      </td>
                      <td class="text-end text-dark" style="font-size: 0.78rem">
                        {{ selectedIssue.sourceType }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark" style="font-size: 0.78rem">
                        Destination URL
                      </td>
                      <td
                        class="text-end text-dark text-truncate"
                        style="font-size: 0.78rem; max-width: 140px"
                        title="{{ selectedIssue.destinationUrl }}"
                      >
                        {{ selectedIssue.destinationUrl }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark" style="font-size: 0.78rem">
                        Anchor Text
                      </td>
                      <td class="text-end text-dark" style="font-size: 0.78rem">
                        {{ selectedIssue.anchorText }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark" style="font-size: 0.78rem">
                        Link Type
                      </td>
                      <td class="text-end text-dark" style="font-size: 0.78rem">
                        {{ selectedIssue.linkType }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark" style="font-size: 0.78rem">
                        First Detected
                      </td>
                      <td class="text-end text-dark" style="font-size: 0.78rem">
                        {{ selectedIssue.firstDetected }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark" style="font-size: 0.78rem">
                        Last Checked
                      </td>
                      <td class="text-end text-dark" style="font-size: 0.78rem">
                        {{ selectedIssue.lastChecked }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark" style="font-size: 0.78rem">
                        Status
                      </td>
                      <td
                        class="text-end fw-bold"
                        [class]="selectedIssue.statusClass"
                        style="font-size: 0.78rem"
                      >
                        <span
                          class="rounded-pill text-transformNone bg"
                          [class]="getStatusBadgeClass(selectedIssue.status)"
                        >
                          {{ selectedIssue.status }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark" style="font-size: 0.78rem">
                        Impact
                      </td>
                      <td
                        class="text-end fw-bold"
                        [ngClass]="
                          selectedIssue.details === 'High'
                            ? 'text-danger'
                            : 'text-warning'
                        "
                        style="font-size: 0.78rem"
                      >
                        <span
                          class="rounded-pill text-transformNone bg-danger-light text-danger"
                        >
                          {{ selectedIssue.details || selectedIssue.priority }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark" style="font-size: 0.78rem">
                        Authority (DA)
                      </td>
                      <td
                        class="text-end fw-bold text-dark"
                        style="font-size: 0.78rem"
                      >
                        {{ selectedIssue.da }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark" style="font-size: 0.78rem">
                        Relevance
                      </td>
                      <td
                        class="text-end fw-bold text-success"
                        style="font-size: 0.78rem"
                      >
                        <span
                          class="rounded-pill text-transformNone bg-danger-light text-danger"
                        >
                          {{ selectedIssue.relevance }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Issue Details and AI Rationale -->
              <div *ngIf="selectedIssue" class="mt-2 pl-2">
                <h5 class="small fw-bold text-uppercase text-dark font-size11">
                  <strong>Issue Details</strong>
                </h5>
                <p class="small text-muted mb-3">
                  {{ selectedIssue.issueDetails }}
                </p>

                <h5 class="small fw-bold text-uppercase text-dark font-size11">
                  <strong>AI Rationale</strong>
                </h5>
                <p class="small text-muted mb-3">
                  {{ selectedIssue.aiRationale }}
                </p>
                <div class="text-end">
                  <a
                    href="javascript:void(0)"
                    class="small text-primary text-decoration-none fw-bold"
                    >View full history &rarr;</a
                  >
                </div>
              </div>
              <div
                *ngIf="!selectedIssue"
                class="text-center py-4 text-muted small"
              >
                Select an issue or opportunity to review details
              </div>
            </div>
          </div>
        </div>

        <!-- Right side Signals / Recent Local Activity -->
        <div class="col-6 d-flex">
          <div class="card shadow-sm mt-0 mb-4 flex-grow-1">
            <div class="card-body p-3">
              <!-- Signals Table -->
              <div
                class="d-flex justify-content-between align-items-center mb-2"
              >
                <h4 class="small fw-bold text-uppercase mb-0 text-dark">
                  <strong>SIGNALS</strong>
                </h4>
                <a
                  href="javascript:void(0)"
                  class="small text-decoration-none text-primary"
                  style="font-size: 0.75rem"
                  >View all activity</a
                >
              </div>

              <div class="table-responsive mb-3">
                <table
                  class="table table-sm table-borderless small mb-0 align-middle"
                >
                  <thead
                    class="text-uppercase text-muted border-bottom font-size9"
                  >
                    <tr>
                      <th class="head-table"><strong>SIGNAL</strong></th>
                      <th class="head-table"><strong>TO</strong></th>
                      <th class="head-table"><strong>STATUS</strong></th>
                      <th class="head-table"><strong>DATE</strong></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let sig of signals" class="border-bottom-0">
                      <td class="fw-semibold text-dark">{{ sig.signal }}</td>
                      <td class="text-primary">{{ sig.to }}</td>
                      <td>
                        <span
                          class="badge rounded-pill text-transformNone"
                          [class]="getSignalStatusClass(sig.status)"
                        >
                          {{ sig.status }}
                        </span>
                      </td>
                      <td class="text-muted" style="font-size: 0.7rem">
                        {{ sig.date }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Recent Activity -->
              <div
                class="d-flex justify-content-between align-items-center border-top pt-3 mb-2"
              >
                <h4 class="small fw-bold text-uppercase mb-0 text-dark">
                  <strong>RECENT OFF-PAGE ACTIVITY</strong>
                </h4>
                <a
                  href="javascript:void(0)"
                  class="small text-decoration-none text-primary fw-medium"
                  style="font-size: 0.72rem"
                  >View all activity &rarr;</a
                >
              </div>

              <div
                class="activity-list custom-scroll-x pt-1"
                style="font-size: 0.75rem"
              >
                <div style="min-width: 500px">
                  <div
                    *ngFor="let act of recentLocalActivity"
                    class="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom border-light"
                  >
                    <span
                      class="text-dark fw-medium pe-2 text-truncate"
                      style="flex: 1 1 auto; min-width: 250px"
                      title="{{ act.text }}"
                    >
                      {{ act.text }}
                    </span>
                    <span
                      class="text-muted text-nowrap px-3"
                      style="width: 160px; font-size: 0.7rem"
                    >
                      {{ act.date }}
                    </span>
                    <span
                      class="text-dark text-nowrap text-end pl-2"
                      style="width: 70px; font-size: 0.7rem"
                    >
                      By {{ act.actor }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row g-2 mb-4">
        <!-- 1. Backlinks over time -->
        <div class="col-4 pr-0 d-flex">
          <div class="card shadow-sm h-100 mt-0 flex-grow-1">
            <div class="card-header bg-white border-bottom-0 pb-0">
              <h4 class="fw-bold text-uppercase small mb-0 text-dark">
                <strong>Backlinks Over Time</strong>
              </h4>
            </div>
            <!-- Legend -->
            <div
              class="d-flex gap-3 justify-content-center mt-1"
              style="font-size: 0.6rem"
            >
              <span class="d-flex align-items-center gap-1">
                <span
                  style="
                    display: inline-block;
                    width: 10px;
                    height: 2px;
                    background: #28a745;
                    border-radius: 1px;
                  "
                ></span>
                <span class="text-muted pl-1">New Links</span>
              </span>
              <span class="d-flex align-items-center gap-1 pl-3">
                <span
                  style="
                    display: inline-block;
                    width: 10px;
                    height: 2px;
                    background: #dc3545;
                    border-radius: 1px;
                  "
                ></span>
                <span class="text-danger pl-1">Lost Links</span>
              </span>
            </div>
            <div
              class="card-body p-0 d-flex flex-column justify-content-between custom-scroll-x"
            >
              <!-- SVG Line Chart -->
              <svg
                viewBox="0 0 200 90"
                preserveAspectRatio="none"
                xmlns="http://www.w3.org/2000/svg"
                style="
                  width: 100%;
                  min-width: 320px;
                  height: 120px;
                  overflow: visible;
                "
              >
                <!-- Y-axis labels -->
                <text x="2" y="10" font-size="7" fill="#adb5bd">200</text>
                <text x="2" y="33" font-size="7" fill="#adb5bd">150</text>
                <text x="2" y="56" font-size="7" fill="#adb5bd">100</text>
                <text x="2" y="79" font-size="7" fill="#adb5bd">50</text>
                <!-- Grid lines -->
                <line
                  x1="22"
                  y1="7"
                  x2="198"
                  y2="7"
                  stroke="#f0f0f0"
                  stroke-width="0.8"
                />
                <line
                  x1="22"
                  y1="30"
                  x2="198"
                  y2="30"
                  stroke="#f0f0f0"
                  stroke-width="0.8"
                />
                <line
                  x1="22"
                  y1="53"
                  x2="198"
                  y2="53"
                  stroke="#f0f0f0"
                  stroke-width="0.8"
                />
                <line
                  x1="22"
                  y1="76"
                  x2="198"
                  y2="76"
                  stroke="#f0f0f0"
                  stroke-width="0.8"
                />
                <!-- X-axis labels -->
                <text
                  x="22"
                  y="89"
                  font-size="6"
                  fill="#adb5bd"
                  text-anchor="middle"
                >
                  Apr 19
                </text>
                <text
                  x="62"
                  y="89"
                  font-size="6"
                  fill="#adb5bd"
                  text-anchor="middle"
                >
                  Apr 26
                </text>
                <text
                  x="102"
                  y="89"
                  font-size="6"
                  fill="#adb5bd"
                  text-anchor="middle"
                >
                  May 3
                </text>
                <text
                  x="142"
                  y="89"
                  font-size="6"
                  fill="#adb5bd"
                  text-anchor="middle"
                >
                  May 10
                </text>
                <text
                  x="182"
                  y="89"
                  font-size="6"
                  fill="#adb5bd"
                  text-anchor="middle"
                >
                  May 17
                </text>
                <!-- New Links line (green) -->
                <polyline
                  points="22,46 62,37 102,41 142,33 182,35"
                  fill="none"
                  stroke="#28a745"
                  stroke-width="1.8"
                  stroke-linejoin="round"
                  stroke-linecap="round"
                />
                <circle cx="22" cy="46" r="2.5" fill="#28a745" />
                <circle cx="62" cy="37" r="2.5" fill="#28a745" />
                <circle cx="102" cy="41" r="2.5" fill="#28a745" />
                <circle cx="142" cy="33" r="2.5" fill="#28a745" />
                <circle cx="182" cy="35" r="2.5" fill="#28a745" />
                <!-- Lost Links line (red) -->
                <polyline
                  points="22,65 62,67 102,61 142,69 182,62"
                  fill="none"
                  stroke="#dc3545"
                  stroke-width="1.8"
                  stroke-linejoin="round"
                  stroke-linecap="round"
                />
                <circle cx="22" cy="65" r="2.5" fill="#dc3545" />
                <circle cx="62" cy="67" r="2.5" fill="#dc3545" />
                <circle cx="102" cy="61" r="2.5" fill="#dc3545" />
                <circle cx="142" cy="69" r="2.5" fill="#dc3545" />
                <circle cx="182" cy="62" r="2.5" fill="#dc3545" />
              </svg>
            </div>
          </div>
        </div>

        <!-- 2. New vs Lost Links -->
        <div class="col-4 pr-0 d-flex">
          <div class="card shadow-sm h-100 mt-0 d-flex flex-column flex-grow-1">
            <div class="card-header bg-white border-bottom-0 pb-0">
              <h4 class="fw-bold text-uppercase small mb-0 text-dark">
                <strong>New vs Lost Links</strong>
              </h4>
            </div>
            <div
              class="card-body p-2 d-flex justify-content-start gap-2 flex-grow-1 custom-scroll-x"
            >
              <!-- Donut -->
              <div
                class="eligibility-donut flex-shrink-0"
                [style.background]="
                  'conic-gradient(#28a745 0% 82%, #dc3545 82% 100%)'
                "
                style="
                  width: 70px;
                  height: 70px;
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <div
                  class="bg-white rounded-circle d-flex flex-column align-items-center justify-content-center"
                  style="width: 54px; height: 54px"
                >
                  <span
                    class="fw-bold text-dark mb-0"
                    style="font-size: 0.85rem"
                    >+{{ netLinks.net }}</span
                  >
                  <span
                    class="text-muted text-center"
                    style="font-size: 0.45rem"
                    >Net Links</span
                  >
                </div>
              </div>
              <!-- Legend -->
              <div class="pl-1" style="font-size: 0.62rem">
                <div class="d-flex align-items-center gap-1 mb-1">
                  <span class="dot dot-green flex-shrink-0"></span>
                  <span class="fw-bold text-success ms-auto ps-1 pl-1">{{
                    netLinks.new
                  }}</span>
                  <span class="text-muted pl-1">New Links</span>
                </div>
                <div class="d-flex align-items-center gap-1">
                  <span class="dot dot-red flex-shrink-0"></span>
                  <span class="fw-bold text-danger ms-auto ps-1 pl-1">{{
                    netLinks.lost
                  }}</span>
                  <span class="text-muted pl-1">Lost Links</span>
                </div>
                <a
                  href="javascript:void(0)"
                  class="small text-decoration-none text-primary d-block mt-2"
                  style="font-size: 0.7rem"
                  >View full report &rarr;</a
                >
              </div>
            </div>
          </div>
        </div>

        <!-- 3. Top Linking Pages -->
        <div class="col-4 pr-0 d-flex">
          <div class="card shadow-sm h-100 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 pb-1 d-flex align-items-center w-100"
            >
              <h4 class="fw-bold text-uppercase small mb-0 text-dark">
                <strong>Top Linking Pages</strong>
              </h4>
              <a
                href="javascript:void(0)"
                class="small text-decoration-none text-primary ms-auto pl-1"
                style="font-size: 0.6rem"
              >
                View full report &rarr;
              </a>
            </div>
            <div class="card-body p-2 pt-1 custom-scroll-x">
              <table
                class="table table-sm table-borderless mb-0 w-100"
                style="font-size: 0.68rem"
              >
                <thead>
                  <tr class="border-bottom">
                    <th
                      class="text-uppercase text-dark fw-bold ps-0 pb-1 head-table"
                      style="font-size: 0.6rem; letter-spacing: 0.4px"
                    >
                      <strong>Page</strong>
                    </th>
                    <th
                      class="text-uppercase text-dark fw-bold text-end pe-0 pb-1 text-nowrap head-table"
                      style="font-size: 0.6rem; letter-spacing: 0.4px"
                    >
                      <strong>Ref. Domains</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let page of topLinkingPages"
                    class="border-bottom border-light"
                  >
                    <td class="ps-0 py-1">
                      <span
                        class="text-truncate text-primary d-inline-block"
                        style="max-width: 130px"
                        title="{{ page.page }}"
                        >{{ page.page }}</span
                      >
                    </td>
                    <td class="fw-bold text-dark text-end pe-0 py-1">
                      {{ page.count }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="row g-2 mb-4">
        <!-- 4. Anchor Text Distribution -->
        <div class="col-4 pr-0 d-flex">
          <div class="card shadow-sm h-100 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 pb-0 d-flex align-items-center w-100"
            >
              <h4 class="fw-bold text-uppercase small mb-0 text-dark">
                <strong>Anchor Text Dist.</strong>
              </h4>
              <a
                href="javascript:void(0)"
                class="small text-decoration-none text-primary ms-auto pl-1"
                style="font-size: 0.6rem"
              >
                View full report &rarr;
              </a>
            </div>
            <div
              class="card-body p-2 d-flex justify-content-start gap-2 custom-scroll-x"
            >
              <!-- Donut -->
              <div
                class="eligibility-donut flex-shrink-0"
                [style.background]="
                  'conic-gradient(#0d6efd 0% 35%, #fd7e14 35% 55%, #198754 55% 70%, #ffc107 70% 84%, #adb5bd 84% 100%)'
                "
                style="
                  width: 70px;
                  height: 70px;
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <div
                  class="bg-white rounded-circle d-flex flex-column align-items-center justify-content-center"
                  style="width: 54px; height: 54px"
                >
                  <span
                    class="fw-bold text-dark mb-0"
                    style="font-size: 0.72rem"
                    >1842</span
                  >
                  <span
                    class="text-muted text-center"
                    style="font-size: 0.42rem"
                    >Total Links</span
                  >
                </div>
              </div>
              <!-- Legend -->
              <div class="pl-1 w-100" style="font-size: 0.6rem">
                <div class="d-flex align-items-center gap-1 mb-1 w-100">
                  <span
                    style="
                      display: inline-block;
                      width: 8px;
                      height: 8px;
                      border-radius: 50%;
                      background: #0d6efd;
                      flex-shrink: 0;
                    "
                  ></span>
                  <span class="text-muted pl-1">Brand</span>
                  <span class="fw-bold ms-auto ps-1"
                    >{{ anchorDistribution.brand }}%</span
                  >
                </div>
                <div class="d-flex gap-1 mb-1 w-100">
                  <span
                    style="
                      display: inline-block;
                      width: 8px;
                      height: 8px;
                      border-radius: 50%;
                      background: #fd7e14;
                      flex-shrink: 0;
                    "
                  ></span>
                  <span class="text-muted pl-1">Partial</span>
                  <span class="fw-bold ms-auto ps-1"
                    >{{ anchorDistribution.partialMatch }}%</span
                  >
                </div>
                <div class="d-flex align-items-center gap-1 mb-1 w-100">
                  <span
                    style="
                      display: inline-block;
                      width: 8px;
                      height: 8px;
                      border-radius: 50%;
                      background: #198754;
                      flex-shrink: 0;
                    "
                  ></span>
                  <span class="text-muted pl-1">Exact</span>
                  <span class="fw-bold ms-auto ps-1"
                    >{{ anchorDistribution.exactMatch }}%</span
                  >
                </div>
                <div class="d-flex align-items-center gap-1 mb-1 w-100">
                  <span
                    style="
                      display: inline-block;
                      width: 8px;
                      height: 8px;
                      border-radius: 50%;
                      background: #ffc107;
                      flex-shrink: 0;
                    "
                  ></span>
                  <span class="text-muted pl-1">Generic</span>
                  <span class="fw-bold ms-auto ps-1"
                    >{{ anchorDistribution.generic }}%</span
                  >
                </div>
                <div class="d-flex align-items-center gap-1 w-100">
                  <span
                    style="
                      display: inline-block;
                      width: 8px;
                      height: 8px;
                      border-radius: 50%;
                      background: #adb5bd;
                      flex-shrink: 0;
                    "
                  ></span>
                  <span class="text-muted pl-1">Other</span>
                  <span class="fw-bold ms-auto ps-1"
                    >{{ anchorDistribution.other }}%</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 5. Link Type -->
        <div class="col-4 pr-0 d-flex">
          <div class="card shadow-sm h-100 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 pb-0 d-flex align-items-center w-100"
            >
              <h4 class="fw-bold text-uppercase small mb-0 text-dark">
                <strong>Link Type</strong>
              </h4>
              <a
                href="javascript:void(0)"
                class="small text-decoration-none text-primary ms-auto pl-1"
                style="font-size: 0.6rem"
              >
                View full report &rarr;
              </a>
            </div>
            <div
              class="card-body p-2 d-flex justify-content-start gap-2 custom-scroll-x"
            >
              <!-- Donut -->
              <div
                class="eligibility-donut flex-shrink-0"
                [style.background]="
                  'conic-gradient(#198754 0% 72%, #0d6efd 72% 94%, #fd7e14 94% 98%, #adb5bd 98% 100%)'
                "
                style="
                  width: 70px;
                  height: 70px;
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <div
                  class="bg-white rounded-circle d-flex flex-column align-items-center justify-content-center"
                  style="width: 54px; height: 54px"
                >
                  <span
                    class="fw-bold text-dark mb-0"
                    style="font-size: 0.72rem"
                    >1842</span
                  >
                  <span
                    class="text-muted text-center"
                    style="font-size: 0.42rem"
                    >Total Links</span
                  >
                </div>
              </div>
              <!-- Legend -->
              <div class="pl-1 w-100" style="font-size: 0.6rem">
                <div class="d-flex align-items-center gap-1 mb-1 w-100">
                  <span
                    style="
                      display: inline-block;
                      width: 8px;
                      height: 8px;
                      border-radius: 50%;
                      background: #198754;
                      flex-shrink: 0;
                    "
                  ></span>
                  <span class="text-muted pl-1">Dofollow</span>
                  <span class="fw-bold text-success ms-auto ps-1"
                    >{{ linkTypeDistribution.dofollow }}%</span
                  >
                </div>
                <div class="d-flex align-items-center gap-1 mb-1 w-100">
                  <span
                    style="
                      display: inline-block;
                      width: 8px;
                      height: 8px;
                      border-radius: 50%;
                      background: #0d6efd;
                      flex-shrink: 0;
                    "
                  ></span>
                  <span class="text-muted pl-1">Nofollow</span>
                  <span class="fw-bold text-info ms-auto ps-1"
                    >{{ linkTypeDistribution.nofollow }}%</span
                  >
                </div>
                <div class="d-flex align-items-center gap-1 mb-1 w-100">
                  <span
                    style="
                      display: inline-block;
                      width: 8px;
                      height: 8px;
                      border-radius: 50%;
                      background: #fd7e14;
                      flex-shrink: 0;
                    "
                  ></span>
                  <span class="text-muted pl-1">UGC</span>
                  <span class="fw-bold ms-auto ps-1"
                    >{{ linkTypeDistribution.ugc }}%</span
                  >
                </div>
                <div class="d-flex align-items-center gap-1 w-100">
                  <span
                    style="
                      display: inline-block;
                      width: 8px;
                      height: 8px;
                      border-radius: 50%;
                      background: #adb5bd;
                      flex-shrink: 0;
                    "
                  ></span>
                  <span class="text-muted pl-1">Sponsored</span>
                  <span class="fw-bold ms-auto ps-1"
                    >{{ linkTypeDistribution.sponsored }}%</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 6. Authority Scores (DA) -->
        <div class="col-4 d-flex">
          <div
            class="card shadow-sm h-100 mt-0 flex-grow-1 text-nowrap custom-scroll-x"
          >
            <div
              class="card-header bg-white border-bottom-0 pb-0 d-flex align-items-center text-wrap"
            >
              <h4 class="fw-bold text-uppercase small mb-0 text-dark">
                <strong>Authority Scores</strong>
              </h4>
              <a
                href="javascript:void(0)"
                class="small text-decoration-none text-primary ms-auto pl-1"
                style="font-size: 0.6rem"
              >
                View full report &rarr;
              </a>
            </div>
            <div class="card-body p-2 custom-scroll-x">
              <div style="font-size: 0.63rem">
                <div
                  *ngFor="let score of authorityScores"
                  class="d-flex align-items-center mb-1"
                >
                  <span
                    style="width: 30px"
                    class="fw-bold text-dark text-nowrap"
                  >
                    {{ score.label }}
                  </span>

                  <div
                    class="progress flex-grow-1 mx-1 align-self-center"
                    style="
                      height: 5px;
                      background: #e9ecef;
                      margin-top: 0;
                      margin-bottom: 0;
                    "
                  >
                    <div
                      class="progress-bar bg-success"
                      role="progressbar"
                      [style.width.%]="score.pct"
                    ></div>
                  </div>

                  <span
                    style="width: 20px; line-height: 1"
                    class="text-end text-muted"
                  >
                    {{ score.count }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ── BOTTOM ROW (ACTION CENTER & SIGNALS) ──────────────────────── -->
      <div class="row">
        <!-- Off-Page Action Center (col-8) -->
        <div class="col-12 d-flex">
          <div
            class="card shadow-sm mt-0 h-100 flex-grow-1"
            style="border: 1px solid #c2e0ff"
          >
            <div
              class="card-header bg-white border-bottom-0 pb-0 pt-3 px-3 d-flex align-items-center"
            >
              <h4 class="fw-bold text-uppercase small mb-0 me-3">
                <strong>OFF-PAGE ACTION CENTER</strong>
              </h4>
              <span
                class="badge bg-success-light text-success text-transformNone"
                >1 item selected</span
              >
            </div>

            <div class="card-body p-3">
              <div class="custom-scroll-x pb-2">
                <!-- <div
                  *ngIf="selectedIssue && selectedIssue.actionCenter"
                  class="d-flex flex-nowrap align-items-stretch gap-3 pb-2"
                  style="min-width: 1040px"
                > -->

                <div
                  *ngIf="selectedIssue && selectedIssue.actionCenter"
                  class="row align-items-stretch flex-nowrap mx-0"
                  style="min-width: 900px"
                >
                  <div class="col-12 pt-3 d-flex">
                    <!-- Proposed Action metadata -->
                    <div class="col-3 d-flex flex-column pe-3 border-end pr-1">
                      <div>
                        <h6
                          class="small fw-bold text-dark mb-1 text-uppercase"
                          style="font-size: 0.65rem; letter-spacing: 0.5px"
                        >
                          <strong>SELECTED ACTION</strong>
                        </h6>
                        <p class="fw-bold text-dark font-size12 mb-0">
                          <strong>{{
                            selectedIssue.actionCenter.selectedAction
                          }}</strong>
                        </p>
                      </div>
                      <div class="d-flex flex-column gap-1">
                        <!-- TARGET SOURCE -->
                        <div class="row align-items-center m-0">
                          <span
                            class="col-6 text-dark fw-bold p-0"
                            style="font-size: 0.62rem"
                          >
                            <strong>TARGET SOURCE</strong>
                          </span>

                          <span
                            class="col-6 small fw-semibold text-dark text-truncate p-0"
                          >
                            {{ selectedIssue.actionCenter.targetSource }}
                          </span>
                        </div>

                        <!-- TARGET URL -->
                        <div class="row align-items-center m-0">
                          <span
                            class="col-6 text-dark fw-bold p-0"
                            style="font-size: 0.62rem"
                          >
                            <strong>TARGET URL</strong>
                          </span>

                          <span
                            class="col-6 small fw-semibold text-dark text-truncate p-0"
                            title="{{ selectedIssue.actionCenter.targetUrl }}"
                          >
                            {{ selectedIssue.actionCenter.targetUrl }}
                          </span>
                        </div>

                        <!-- ELEMENT -->
                        <div class="row align-items-center m-0">
                          <span
                            class="col-6 text-dark fw-bold p-0"
                            style="font-size: 0.62rem"
                          >
                            <strong>ELEMENT</strong>
                          </span>

                          <span
                            class="col-6 small fw-semibold text-dark text-truncate p-0"
                          >
                            {{ selectedIssue.actionCenter.element }}
                          </span>
                        </div>

                        <!-- DECISION ORIGIN -->
                        <div class="row align-items-center m-0">
                          <span
                            class="col-6 text-dark fw-bold p-0"
                            style="font-size: 0.62rem"
                          >
                            <strong>DECISION ORIGIN</strong>
                          </span>

                          <span
                            class="col-6 small fw-semibold text-dark text-truncate p-0"
                          >
                            {{ selectedIssue.actionCenter.decisionOrigin }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- Current status -->
                    <div
                      class="col-4 border rounded bg-white p-3 d-flex flex-column justify-content-start ml-1"
                      style="
                        border-color: #cbd5e1 !important;
                        max-height: 152px;
                      "
                    >
                      <h6
                        class="small fw-bold text-dark mb-2 text-uppercase"
                        style="font-size: 0.65rem; letter-spacing: 0.5px"
                      >
                        <strong>CURRENT</strong>
                      </h6>
                      <p
                        class="small text-dark mb-0 lh-base"
                        style="font-size: 0.74rem; white-space: pre-line"
                      >
                        {{ selectedIssue.actionCenter.currentText }}
                      </p>
                    </div>

                    <!-- Arrow -->
                    <div
                      class="d-flex align-items-center justify-content-center px-1"
                      style="flex: 0 0 20px"
                    >
                      <i class="fas fa-arrow-right text-muted"></i>
                    </div>

                    <!-- Proposed strategy -->
                    <div
                      class="col-4 border rounded p-3 d-flex flex-column justify-content-start"
                      style="
                        background-color: #f0fdf4;
                        border-color: #bbf7d0 !important;
                        max-height: 152px;
                      "
                    >
                      <h6
                        class="small fw-bold text-dark mb-2 text-uppercase"
                        style="font-size: 0.65rem; letter-spacing: 0.5px"
                      >
                        <strong>PROPOSED</strong>
                      </h6>
                      <p
                        class="small fw-medium mb-0 lh-base text-dark"
                        style="font-size: 0.74rem; white-space: pre-line"
                      >
                        {{ selectedIssue.actionCenter.proposedText }}
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  *ngIf="selectedIssue && selectedIssue.actionCenter"
                  class="row align-items-stretch flex-nowrap mx-0"
                  style="min-width: 900px"
                >
                  <div class="col-12 pt-3 d-flex">
                    <!-- AI recommendation details -->
                    <div class="d-flex align-items-stretch ms-2 pl-1">
                      <div
                        class="col-7 d-flex flex-column justify-content-between flex-grow-1 pe-3 ml-1 border-right border-muted custom-scroll-y"
                        style="max-height: 152px; overflow-y: auto"
                      >
                        <div>
                          <h6
                            class="small fw-bold text-primary mb-2 text-uppercase"
                            style="font-size: 0.65rem; letter-spacing: 0.5px"
                          >
                            AI RECOMMENDATION
                          </h6>
                          <p
                            class="small text-muted mb-2 lh-sm"
                            style="font-size: 0.74rem"
                          >
                            {{ selectedIssue.actionCenter.aiRecommendation }}
                          </p>
                        </div>
                        <a
                          href="javascript:void(0)"
                          class="small text-primary text-decoration-none fw-medium d-inline-flex align-items-center mt-1"
                        >
                          View full rationale
                          <i
                            class="fas fa-arrow-right ms-1"
                            style="font-size: 0.7rem"
                          ></i>
                        </a>
                      </div>

                      <div
                        class="border-end mx-2"
                        style="border-color: #cbd5e1 !important; height: 100%"
                      ></div>

                      <!-- AI Confidence + Risk Level + Execution Mode -->
                      <div
                        class="col d-flex align-items-flex-start gap-3 ps-2 flex-shrink-0"
                      >
                        <!-- AI Confidence gauge -->
                        <div
                          class="d-flex flex-column align-items-center border-right border-muted pr-1"
                        >
                          <h6
                            class="small fw-bold text-dark mb-2 text-uppercase text-nowrap"
                            style="font-size: 0.6rem; letter-spacing: 0.5px"
                          >
                            <strong>AI CONFIDENCE</strong>
                          </h6>
                          <div
                            class="progress-circle-wrapper"
                            style="
                              position: relative;
                              width: 70px;
                              height: 70px;
                            "
                          >
                            <div
                              class="progress-circle"
                              [style.background]="
                                'conic-gradient(#198754 0% ' +
                                selectedIssue.actionCenter.aiConfidence +
                                '%, #e2e8f0 ' +
                                selectedIssue.actionCenter.aiConfidence +
                                '% 100%)'
                              "
                              style="
                                width: 70px;
                                height: 70px;
                                border-radius: 50%;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                position: relative;
                              "
                            >
                              <div
                                class="bg-white rounded-circle d-flex flex-column align-items-center justify-content-center"
                                style="width: 58px; height: 58px"
                              >
                                <span
                                  class="text-dark fw-bold"
                                  style="font-size: 0.95rem; line-height: 1"
                                >
                                  {{ selectedIssue.actionCenter.aiConfidence }}%
                                </span>
                                <span
                                  class="text-success fw-bold text-uppercase"
                                  style="font-size: 0.5rem; margin-top: 2px"
                                >
                                  High
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Risk Level -->
                        <div
                          class="d-flex flex-column align-items-center pl-1 border-right border-muted pr-1 pl-1"
                        >
                          <h6
                            class="small fw-bold text-dark mb-2 text-uppercase text-nowrap"
                            style="font-size: 0.6rem; letter-spacing: 0.5px"
                          >
                            <strong>RISK LEVEL</strong>
                          </h6>
                          <span
                            class="badge rounded-pill px-2 py-1 fw-semibold text-transformNone"
                            style="font-size: 0.68rem"
                            [ngClass]="
                              (selectedIssue.actionCenter.riskLevel ||
                                'Low') === 'Low'
                                ? 'bg-success-light text-success'
                                : selectedIssue.actionCenter.riskLevel ===
                                    'Medium'
                                  ? 'bg-warning-light text-warning'
                                  : 'bg-danger-light text-danger'
                            "
                          >
                            {{ selectedIssue.actionCenter.riskLevel || "Low" }}
                          </span>
                        </div>

                        <!-- Execution Mode -->
                        <div
                          class="d-flex flex-column align-items-center pl-1 pr-1"
                        >
                          <h6
                            class="small fw-bold text-dark mb-2 text-uppercase text-nowrap"
                            style="font-size: 0.6rem; letter-spacing: 0.5px"
                          >
                            <strong>EXECUTION MODE</strong>
                          </h6>
                          <span
                            class="badge rounded-pill px-2 py-1 fw-semibold text-transformNone text-center"
                            style="
                              font-size: 0.65rem;
                              background-color: #fff3e0;
                              color: #e65100;
                              max-width: 100px;
                              white-space: normal;
                              line-height: 1.3;
                            "
                          >
                            {{ selectedIssue.actionCenter.executionMode }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    *ngIf="!selectedIssue"
                    class="text-center py-4 text-muted small"
                  >
                    Select an item to view outreach proposal details
                  </div>
                </div>

                <!-- Button actions -->
                <div class="border-top pt-3 mt-3">
                  <div class="custom-scroll-x pb-2">
                    <div
                      class="d-flex gap-2 flex-nowrap w-100"
                      style="min-width: 860px"
                    >
                      <button
                        class="btn btn-success fw-medium btn-desicion-mapping flex-grow-1"
                        (click)="approveAction()"
                        [disabled]="saving || !selectedIssue"
                        style="
                          background: linear-gradient(
                            135deg,
                            #10b981 0%,
                            #059669 100%
                          );
                          border-color: #059669;
                          color: white;
                        "
                      >
                        <i class="fas fa-check me-2"></i> Approve &amp;
                        Implement
                      </button>
                      <button
                        class="btn btn-outline-secondary fw-medium btn-desicion-mapping bg-white text-dark flex-grow-1"
                        [disabled]="!selectedIssue"
                        style="border-color: #cbd5e1"
                      >
                        <i class="fas fa-pencil-alt me-2"></i> Edit Action
                      </button>
                      <button
                        class="btn btn-outline-primary border border-primary fw-medium btn-desicion-mapping bg-white flex-grow-1"
                        [disabled]="!selectedIssue"
                        style="color: #a855f7; border-color: #a855f7 !important"
                      >
                        <i class="fas fa-magic me-2"></i> Ask AI to Reconsider
                      </button>
                      <button
                        class="btn btn-outline-danger border border-danger fw-medium btn-desicion-mapping bg-white text-danger flex-grow-1"
                        style="border-color: #fca5a5"
                        (click)="rejectAction()"
                        [disabled]="saving || !selectedIssue"
                      >
                        <i class="fas fa-times-circle me-2"></i> Reject
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-secondary fw-medium btn-desicion-mapping bg-white text-dark flex-grow-1 d-flex justify-content-between align-items-center"
                        [disabled]="!selectedIssue"
                        style="border-color: #cbd5e1"
                      >
                        <span
                          ><i class="fas fa-paper-plane me-2 text-primary"></i>
                          Create Signal</span
                        >
                        <i
                          class="fas fa-chevron-down ms-1 text-muted"
                          style="font-size: 0.65rem"
                        ></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-secondary fw-semibold btn-desicion-mapping bg-white text-dark flex-grow-1 d-flex justify-content-between align-items-center"
                        [disabled]="!selectedIssue"
                        style="border-color: #cbd5e1"
                      >
                        <span
                          ><i class="fas fa-hammer me-2 text-purple"></i> Create
                          Production Need</span
                        >
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-secondary fw-semibold btn-desicion-mapping bg-white text-dark flex-grow-1 d-flex justify-content-between align-items-center"
                        [disabled]="!selectedIssue"
                        style="border-color: #cbd5e1"
                      >
                        <span
                          ><i class="fas fa-ellipsis-h me-2"></i> More
                          Actions</span
                        >
                        <i
                          class="fas fa-chevron-down ms-1 text-muted"
                          style="font-size: 0.65rem"
                        ></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer note -->
        <!-- <div
        class="mt-3 text-muted small d-flex align-items-center border-top pt-3"
      >
        <i class="fas fa-info-circle me-2 pr-2"></i>
        Off-Page SEO manages external backlinks, mentions, authority metrics and
        authority networks. Content changes are handled by On-Page SEO.
        Technical issues are handled by Technical QA.
      </div> -->
      </div>

      <!-- Loading spinner -->
      <div
        *ngIf="loading"
        class="d-flex justify-content-center align-items-center"
        style="min-height: 400px"
      >
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</div>
